import { error } from './sentry';

export const criticalError = (
  e: Error,
  { tags = {}, option = {}, extra = {} }: { tags: object; option: object; extra: object } = {
    tags: {},
    option: {},
    extra: {},
  },
) => {
  error(e, { tags: { ...tags, _error_type: 'critical' }, option, extra });
};
